
import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { Player } from "video-react";
import axios from "../../axios";
// import "..ShowFilesModal/modal.scss"

const ShowEditModal = (props) => {
    const { id } = useParams();
    const [status, setStatus] = useState([]);
    const [item, setItem] = useState();
    const [edit, setEdit] = useState({});
    // console.log("first", props?.id)
    const { data } = props;
    // console.log("dataaa", data)
    const handleStatus = (e) => {
        const ud = Object.assign({}, item);
        ud.status_id = Number(e.target.value);
        // console.log('select', e.target.value);
        setItem(ud);
    };
    const handleDesc = (e) => {
        const ud = Object.assign({}, item);
        ud.description = e.target.value;
        setItem(ud);

    };
    const handleDate = (e) => {
        const ud = Object.assign({}, item);
        ud.date = e.target.value;
        setItem(ud);
    };
    let userId = window.localStorage.getItem("id");
    // console.log('userId', item);

    useEffect(() => {
        axios
            .get(`/case-statuses/id?id=` + props?.id)
            .then((res) => {
                setEdit(res?.data);
                // setFiltered(res?.data);

                // console.log("edit", res?.data)
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);
    const handleFormSubmission = () => {
        axios.put(`/case-statuses/`, item)
            .then((data) => {
                // console.log('mireO', data.data);

                // setTimeout(() => {
                //     props.closeEditModal();
                // }, 300)
            })
            .catch((err) => {
                console.log('error', err);
            });
    }


    useEffect(() => {
        const ud = Object.assign({}, item);
        ud.case_id = Number(id);
        ud.created_by = Number(userId);
        ud.id = props?.id;
        setItem(ud);
    }, [])

    useEffect(() => {
        axios
            .get(`/case-status/all`)
            .then((res) => {
                setStatus(res?.data);
            })
            .catch((err) => {
                console.log(err);
            });

    }, []);
    return (
        <>

            <div className="show_header">
                {/* <h3>Edit Status</h3> */}
                <button className=" myButton close_modal  fa fa-close " onClick={props.closeEditModal} />
            </div>
            <div className="statusModal">
                <div className="container editStatus">

                    <h5 className="mt-4 mb-4">
                        Edit status
                    </h5>


                    <form className="form" onSubmit={handleFormSubmission}>
                        <select className="form-control mb-2" name="status" onChange={handleStatus} required>
                            {status?.map((el) => {
                                return (
                                    <option value={el.id} selected={edit?.status_id === el.id ? true : ""}>{el.status_al}</option>

                                );
                            })}
                        </select>
                        <textarea className="form-control mb-2" onChange={handleDesc} defaultValue={edit?.description} required></textarea>
                        <input type="date" className="form-control mb-2" onChange={handleDate} defaultValue={edit?.date?.slice(0, 10)} required></input>
                        <button type="submit" className="btn mb-2 btnEdit">Edit</button>
                    </form>
                </div>


            </div>
        </>
    )
}

export default ShowEditModal